/**
 * The name of the default namespace that is used when a namespace is not provided
 */
export const DEFAULT_NAMESPACE = Symbol('DEFAULT_NAMESPACE');